export enum ActivityEntityKind {
  ENTRY = "ENTRY",
  KANBAN_CARD = "KANBAN_CARD",
  KANBAN = "KANBAN",
  KANBAN_COLUMN = "KANBAN_COLUMN",
  TASK = "TASK",
  MODULE = "MODULE",
  FORM = "FORM",
}
